// extracted by mini-css-extract-plugin
export default {"search_container":"Search_search_container__TJHJy","noposts":"Search_noposts__kISlJ"};